import { getPropertyByPath } from '../objectOperations.utils';

export const xAdrOverviewEnumeration = 'enumeration';
export const xAdrOverviewAlerts = 'alerts';
export const xAdrOverviewCves = 'CVE';
export const xAdrOverviceIndicatorsOfRisks = 'risk_indicator';
export const NARRATIVE_DICTIONARY_CHAPTER = 'sentences';

/**
 * takes a slice of data (enumeration / alert), searches for phrases between start and end indexes,
 * creates the {key:value} object used for replacing text in the phrases dictionary
 * @param dataSlice
 * @param phrases
 * @param version
 * @param {string} sliceType
 * @param {string} summaryType
 * @param dictionary
 * @param dictionaryKey
 * @param processParamsToReplace
 * @returns {any}
 */
export function getParams(
  dataSlice: any,
  phrases: any,
  version: number,
  sliceType: string,
  summaryType: string,
  dictionary: any,
  dictionaryKey: string,
  processParamsToReplace: Function
): any | false {
  const params = {};
  let paramIndex = 0;
  for (const data of dataSlice) {
    const start = data['value'][0];
    const end = data['value'][1];
    const template: string[] = [];

    for (let i = start; i <= end; i++) {
      if (phrases[i] === undefined) {
        return false;
      }

      if (sliceType === xAdrOverviewAlerts && (version === undefined || version === 0) ) {
        // in case that there will be more than 1 param for alerts in the future
        const alertsTemplate = Object.values(processParamsToReplace(phrases[i]['params'], '')).join('');
        template.push(alertsTemplate);
      } else {
        const { dictionaryTemplate } = getReplacedDictionaryTemplateAndPath(
          phrases[i],
          summaryType,
          dictionary,
          dictionaryKey,
          NARRATIVE_DICTIONARY_CHAPTER,
          processParamsToReplace,
          version
        );

        template.push(dictionaryTemplate);
      }

      // check if the current phrase template was not found
      if (template[template.length - 1] === '') {
        return false;
      }
    }

    params[sliceType + '_' + paramIndex] = template.join('');
    paramIndex++;
  }

  return params;
}

/**
 * get the sentence template, replace the params and return the dictionaryPath as well as the replaced template
 * @param phrase
 * @param {string} type
 * @param dictionary
 * @param dictionaryKey
 * @param {string} dictionaryChapterKey
 * @param processParamsToReplace
 * @returns {{dictionaryTemplate: any, dictionaryPath: string}}
 */
export function getReplacedDictionaryTemplateAndPath(
  phrase: any,
  type: string,
  dictionary: any,
  dictionaryKey: string,
  dictionaryChapterKey: string,
  processParamsToReplace: Function,
  version: number
) {
  const summaryID = phrase['id'];
  const summaryVersion = phrase['version'];
  const dictionaryChapter = dictionaryKey + type + '.' + dictionaryChapterKey;
  let dictionaryPath = dictionaryChapter + '.' + summaryID + '.' + summaryVersion;
  let dictionaryTemplate = getPropertyByPath(dictionary, dictionaryPath, '');

  if (phrase.hasOwnProperty('subtype')) {
    // this implies that params is not empty
    const summarySubtype = phrase['subtype'];
    const summaryParams = phrase['params'];
    dictionaryPath += '.' + summarySubtype;
    const notReplacedDictionaryTemplate = getPropertyByPath(dictionary, dictionaryPath, '');

    /*
     * I need to include the dictionary template in the gz-link component. The line above gives me the template.
     *
     * I can't move here the gz-link generation because 'processParamsToReplace' adds specific attributes to the gz-link component
     * based on different criteria while iterating the params, (and does that by calling multiple methods with custom logic)
     *
     * I can send the template in the 'processParamsToReplace' function in order to include it in the gz-link but I need
     * to redesign that function for it to support multiple placeholders.
     */
    dictionaryTemplate = processParamsToReplace(summaryParams, notReplacedDictionaryTemplate, version);
  }

  return {
    dictionaryTemplate,
    dictionaryPath,
  };
}
